import Settings from 'src/Settings';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const rewardStatusThemeConfig = {
  [BuildTypeEnum.canteen]: {
    circlePointsIndicatorFillColor: Styles.Colors.Canteen.green,
    pointsIndicatorFillColor: Styles.Colors.Canteen.green,
    textFontFamily: Styles.FontFamily.robotoRegular,
    indicatorGradient1: Styles.secondaryColor,
    indicatorGradient2: Styles.primaryColor,
    statusExpires: Localized.Labels.rewards_expires_cp,
    redeemRewardStatus: [],
    rewardStatusTextColor: Styles.Colors.Canteen.green,
  },
  [BuildTypeEnum.default]: {
    circlePointsIndicatorFillColor: Styles.Colors.PayNew.primary01,
    pointsIndicatorFillColor: Styles.blueRevolve,
    textFontFamily: Styles.FontFamily.aeonikRegular,
    indicatorGradient1: Styles.Colors.PayNew.support03,
    indicatorGradient2: '#006DFF',
    statusExpires: Localized.Labels.rewards_expires,
    redeemRewardStatus: [
      Styles.Colors.PayNew.support01,
      Styles.Colors.PayNew.blueHuesBase07,
    ],
    rewardStatusTextColor: Styles.Colors.PayNew.black01,
  },
  [BuildTypeEnum.aramark]: {
    circlePointsIndicatorFillColor: Styles.Colors.Aramark.primary,
    pointsIndicatorFillColor: Styles.Colors.Aramark.primary,
    textFontFamily: Styles.FontFamily.gothamRegular,
    indicatorGradient1: Styles.Colors.PayNew.support03,
    indicatorGradient2: Styles.Colors.Aramark.primary,
    statusExpires: Localized.Labels.rewards_expires,
    redeemRewardStatus: [
      Styles.Colors.PayNew.support01,
      Styles.Colors.PayNew.blueHuesBase07,
    ],
    rewardStatusTextColor: Styles.Colors.PayNew.black01,
  },
  [BuildTypeEnum.companykitchen]: {
    pointsIndicatorFillColor: Styles.Colors.CompanyKitchen.green,
    textFontFamily: Styles.FontFamily.aeonikRegular,
    indicatorGradient1: Styles.Colors.PayNew.support03,
    indicatorGradient2: '#006DFF',
    circlePointsIndicatorFillColor: Styles.Colors.CompanyKitchen.green,
    statusExpires: Localized.Labels.rewards_expires_cp,
    redeemRewardStatus: [],
    rewardStatusTextColor: Styles.Colors.CompanyKitchen.green,
  },
  [BuildTypeEnum.refive]: {
    pointsIndicatorFillColor: Styles.blueRevolve,
    textFontFamily: Styles.FontFamily.figtreeRegular,
    indicatorGradient1: Styles.Colors.PayNew.support03,
    indicatorGradient2: '#006DFF',
    circlePointsIndicatorFillColor: '#006DFF',
    statusExpires: Localized.Labels.rewards_expires,
    redeemRewardStatus: [Styles.Colors.Refive.navy, Styles.Colors.Refive.navy],
    rewardStatusTextColor: Styles.Colors.Refive.green,
  },
};
export const rewardStatusConfig = rewardStatusThemeConfig[Settings.buildType];
